import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MessageBlockType } from '../../../domain/enums/message-block-type.enum';
import { ChatAction } from '../../../domain/models/chat-action.model';
import { MessageBlock } from '../../../domain/models/message-block.model';
import { SourceReference } from '../../../domain/models/source-reference.model';

@Component({
  selector: 'talk-to-your-data-message-renderer',
  templateUrl: './message-renderer.component.html',
  styleUrls: ['./message-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageRendererComponent {
  readonly messageBlockType = MessageBlockType;

  @Input() block!: MessageBlock;

  trackByActionId(index: number, action: ChatAction): string {
    return action.id || String(index);
  }

  trackBySourceReferenceId(index: number, source: SourceReference): string {
    return source.id || String(index);
  }
}
